<div class="slideout-content">
    <div class="modalsd modal-slide-in sdfade new-role-modal" id="modals-slide-in">
      <div class="modal-dialog">
        <form class="add-new-role modal-content pt-0" #newRoleForm="ngForm"  (ngSubmit)="(newRoleForm.form.valid)">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="toggleSidebar('new-role-sidebar')"
          >
            ×
          </button>
          <div class="modal-header mb-1">
            <h5 class="modal-title" id="exampleModalLabel">Yeni Rol</h5>
          </div>
          <div class="modal-body flex-grow-1">
            <div class="form-group">
              <div class="form-group">
                <label class="form-label" for="basic-icon-default-fullname">Rol Adı</label>
                <input
                  type="text"
                  id="basic-icon-default-fullname"
                  class="form-control dt-uname"
                  placeholder="Rol adı giriniz."
                  aria-label="jdoe1"
                  aria-describedby="basic-icon-default-fullname2"
                  name="rolName"
                  [(ngModel)]="rolName"
                  [class.error]="newRoleForm.submitted && FrolName.invalid"
                  #FrolName="ngModel"
                  required
                />
                <span *ngIf="newRoleForm.submitted && FrolName.invalid" class="invalid-form">
                  <small class="form-text text-danger" *ngIf="FrolName.errors.required">Rol adı boş olamaz!</small>
                </span>
              </div>
            </div>
             
            <button type="submit" class="btn btn-primary mr-1" (click)="submit(newRoleForm)" rippleEffect>Ekle</button>
            <button
              type="reset"
              class="btn btn-outline-secondary"
              (click)="toggleSidebar('new-role-sidebar')"
              rippleEffect
            >
              İptal
            </button>
          </div>
         
         
          
        </form>
      </div>
    </div>
  </div>
  